import { styled } from '@mui/material/styles';
import MuiBox from '@mui/material/Box';
import { Typography, Button } from '@raisin/components-lib';

export const Box = styled(MuiBox)(({ theme }) => ({
  backgroundColor: theme.palette.blue10.main,
}));

export const ErrorLabel = styled(Typography)(({ theme }) => ({
  position: 'absolute',
  inset: 0,
  width: '80%',
  height: 450,
  margin: 'auto',
  fontWeight: theme.typography.body1.fontWeight,
  textAlign: 'center',
}));

export const LegendValue = styled('span')(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  textAlign: 'left',
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const LegendElement = styled(MuiBox)<{ $noBorder: boolean; $noMDBorder: boolean }>(
  ({ $noBorder, $noMDBorder, theme }) => ({
    display: 'flex',
    flexFlow: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'center',
    ...(!$noBorder && !$noMDBorder
      ? {
          borderBottom: `1px solid ${theme.palette.black40.main}`,
          paddingBottom: theme.spacing(4),
        }
      : {
          paddingTop: theme.spacing(4),
        }),
    [theme.breakpoints.down('lg')]: {
      ...($noMDBorder && {
        borderBottom: `1px solid ${theme.palette.black40.main}`,
        paddingBottom: theme.spacing(4),
      }),
    },
  }),
);

export const Tooltip = styled(MuiBox)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  backgroundColor: theme.palette.white.main,
  borderRadius: theme.shape.borderRadius,
}));

export const LegendTitle = styled(Typography)(({ theme }) => ({
  display: 'inline-block',
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.body2.fontSize,
  },
}));

export const LengendBox = styled(MuiBox)(({ theme }) => ({
  backgroundColor: theme.palette.white.main,
  border: `1px solid ${theme.palette.black40.main}`,
  borderRadius: 8,
}));

export const RiskParagraph = styled(Typography)(({ theme }) => ({
  a: {
    color: theme.palette.black80.main,
  },

  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.subtitle1.fontSize,
  },
}));

export const Link = styled(Button)(({ theme }) => ({
  color: theme.palette.black80.main,
  textDecoration: 'underline',
  [theme.breakpoints.down('lg')]: {
    justifyContent: 'left',
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  [theme.breakpoints.down('lg')]: {
    fontSize: theme.typography.subtitle1.fontSize,
  },
}));
